import { type ComponentPropsWithoutRef, forwardRef, type Ref } from "react";
import { eachHourOfInterval, startOfDay, endOfDay, getHours } from "date-fns";

import { format } from "common/core/format/date";
import { Select } from "common/core/form/select";

const ITEMS = Object.freeze(
  eachHourOfInterval({
    start: startOfDay(new Date(2021, 10, 21)),
    end: endOfDay(new Date(2021, 10, 21)),
  }).map((value) => ({
    label: format({ value, formatStyle: "p" }) || "",
    value: getHours(value) * 60,
  })),
);

type Props = Omit<ComponentPropsWithoutRef<typeof Select>, "items">;

function TimeField(props: Props, ref: Ref<HTMLSelectElement>) {
  return <Select {...props} items={ITEMS} ref={ref} />;
}

export default forwardRef(TimeField);
